import React from 'react';
import { InitiatorUserProps } from './types';
import { AvatarWrapper, MainInfo, MainInfoWrapper, NameWrapper, Wrapper } from './initiator-user.styles';
import { Photo } from '@shared/ui/photo/photo';
import { Typography } from '@shared/ui/typography/typography';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { UserInfoTooltip } from '@shared/ui/user-info-tooltip/user-info-tooltip';

export const InitiatorUser: React.FC<InitiatorUserProps> = ({
    firstName,
    lastName,
    middleName,
    organizationPost,
    avatarUrl,
    children,
    tooltipData,
}) => {
    const initiatorName = userName({
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
    });

    return (
        <Wrapper>
            <MainInfoWrapper>
                <AvatarWrapper>
                    <Photo photoUrl={avatarUrl} name={initiatorName.full} size='l' />
                </AvatarWrapper>
                <MainInfo>
                    <NameWrapper>
                        {initiatorName.full && (
                            <Typography size='subtitle2' color='neutral_90'>
                                {initiatorName.full}
                            </Typography>
                        )}
                        {tooltipData && (
                            <UserInfoTooltip
                                tooltipProps={{ position: 'top' }}
                                tooltipData={{
                                    departmentName: tooltipData.department?.name,
                                    email: tooltipData.email || '',
                                    phoneNumber: tooltipData.phoneNumber || '',
                                }}
                            />
                        )}
                    </NameWrapper>
                    {organizationPost && (
                        <Typography size='body1_short' color='neutral_50'>
                            {organizationPost}
                        </Typography>
                    )}
                </MainInfo>
            </MainInfoWrapper>
            {children}
        </Wrapper>
    );
};
